// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    InputAdornment,
    Typography,
    CircularProgress,
    Divider,
    Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PeopleIcon from "@mui/icons-material/People";
import Paginador from "../../../Alias/Componentes/Paginador";
import { EMAILS_PER_PAGE } from "../../../Contantes/Constantes";
import usePagination from "../../../Componentes/usePagination";
import { useDifusiones } from "../../context/DifusionesContext";
import { useBody } from "../../../Body/state/BodyContext";

export default function BuscarDestinatarios({ destinatarios, difusionId, difusionDate }) {
    const [currentPage, setCurrentPage] = useState(1);
    const { setMessage } = useBody();
    const { paginateAliases } = usePagination(destinatarios, EMAILS_PER_PAGE);
    const [filtrados, setFiltrados] = useState(destinatarios);
    const [emailsForDisplay, setEmailsForDisplay] = useState(paginateAliases(destinatarios, 1));
    const { obtenerAperturasDifusion } = useDifusiones();
    const [destSinAbrir, setDestSinAbrir] = useState([]);
    const [loading, setLoading] = useState(true);
    const [diferenciaMeses, setDiferenciaMeses] = useState(0);
    const [search, setSearch] = useState("");

    const obtenerAperturas = async (id) => {
        setLoading(true);
        try {
            const now = new Date();
            const difusionFecha = new Date(difusionDate);
            let diferencia = (now.getFullYear() - difusionFecha.getFullYear()) * 12 + (now.getMonth() - difusionFecha.getMonth());
            if (now.getDate() < difusionFecha.getDate()) diferencia -= 1;
            setDiferenciaMeses(diferencia);
            if (diferencia < 1) {
                const response = await obtenerAperturasDifusion(id);
                setDestSinAbrir(response.destinatarios || []);
            }
        } catch (error) {
            console.error("Error al obtener aperturas:", error);
            setMessage("Hubo un error al obtener las aperturas de la difusión.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerAperturas(difusionId);
    }, [difusionId, difusionDate]);

    useEffect(() => {
        const resultado = destinatarios.filter(email =>
            email.toLowerCase().includes(search.toLowerCase())
        );
        setFiltrados(resultado);
        setCurrentPage(1);
        setEmailsForDisplay(paginateAliases(resultado, 1));
    }, [search, destinatarios]);

    useEffect(() => {
        setEmailsForDisplay(paginateAliases(filtrados, currentPage));
    }, [currentPage]);

    const sinAbrirEnLista = destSinAbrir.filter(email => destinatarios.includes(email));
    const abrieron = diferenciaMeses < 1 && !loading
        ? destinatarios.length - sinAbrirEnLista.length
        : null;
    const pageCount = Math.ceil(filtrados.length / EMAILS_PER_PAGE);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Chip
                    icon={<PeopleIcon />}
                    label={`${destinatarios.length} Destinatarios`}
                    variant="outlined"
                />
                {abrieron !== null && (
                    <>
                        <Chip
                            icon={<CheckCircleIcon sx={{ color: '#388e3c !important' }} />}
                            label={`${abrieron} Leídos`}
                            variant="outlined"
                            sx={{ borderColor: '#388e3c', color: '#388e3c' }}
                        />
                        <Chip
                            icon={<CancelIcon sx={{ color: '#ad3939 !important' }} />}
                            label={`${sinAbrirEnLista.length} No leídos`}
                            variant="outlined"
                            sx={{ borderColor: '#ad3939', color: '#ad3939' }}
                        />
                    </>
                )}
            </Box>

            <TextField
                size="small"
                placeholder="Buscar destinatario..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                        </InputAdornment>
                    ),
                }}
                fullWidth
            />

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 500 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
                        {emailsForDisplay.length === 0 ? (
                            <Box sx={{ p: 3, textAlign: 'center' }}>
                                <Typography color="text.secondary" variant="body2">
                                    No se encontraron destinatarios.
                                </Typography>
                            </Box>
                        ) : (
                            emailsForDisplay.map((email, i) => (
                                <React.Fragment key={email}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        px: 2,
                                        py: 1.25,
                                        gap: 1,
                                        '&:hover': { bgcolor: 'action.hover' },
                                        transition: 'background-color 0.15s',
                                    }}>
                                        <Typography variant="body2" noWrap sx={{ flex: 1 }}>
                                            {email}
                                        </Typography>
                                        {diferenciaMeses < 1 && !loading && (
                                            sinAbrirEnLista.includes(email)
                                                ? <CancelIcon fontSize="small" sx={{ color: '#ad3939' }} />
                                                : <CheckCircleIcon fontSize="small" sx={{ color: '#388e3c' }} />
                                        )}
                                    </Box>
                                    {i < emailsForDisplay.length - 1 && <Divider />}
                                </React.Fragment>
                            ))
                        )}
                    </Box>

                    <Paginador
                        aliasesCount={filtrados.length}
                        pageCount={pageCount}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </>
            )}
        </Box>
    );
}
